/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { select } from '@wordpress/data';
import {
	__experimentalPanelColorGradientSettings as PanelColorGradientSettings,
} from '@wordpress/block-editor';
import { has, isEmpty } from 'lodash';
import { Flex, FlexItem, Button, ColorPalette, BaseControl } from '@wordpress/components';

/**
 * Internal dependencies.
 */
import { generateCustomStyleCode } from '../../../extensions/custom-styles';

class ColorOptions extends Component {
	constructor( props ) {
		super( props );
		this.updateStyles = this.updateStyles.bind( this );
	}

	updateStyles( styles ) {
		const { setAttributes, clientId, attributes } = this.props;
		const { blockAdvanceOptions } = attributes;

		const _styles = {
			...blockAdvanceOptions,
			...styles,
		};

		setAttributes( { blockClientId: clientId } );
		generateCustomStyleCode( _styles, { ...this.props }, true );
		setAttributes( { blockAdvanceOptions: { ..._styles } } );
	}
	colorFields() {
		const { attributes } = this.props;
		const { blockAdvanceOptions } = attributes;
		const fields = [];
		const backgroundColor = has( blockAdvanceOptions, 'backgroundColor' ) && ! isEmpty( blockAdvanceOptions.backgroundColor ) ? blockAdvanceOptions.backgroundColor : undefined;
		const backgroundGradient = has( blockAdvanceOptions, 'backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.backgroundGradient ) ? blockAdvanceOptions.backgroundGradient : undefined;
		fields.push( {
			label: __( 'Background Color' ),
			colorValue: backgroundColor,
			gradientValue: backgroundGradient,
			onGradientChange: ( val ) => {
				if ( isEmpty( val ) ) {
					return;
				}
				const styles = {
					backgroundGradient: val,
					backgroundColor: undefined,
				};
				this.updateStyles( styles );
			},
			onColorChange: ( val ) => {
				if ( isEmpty( val ) ) {
					return;
				}
				const styles = {
					backgroundColor: val,
					backgroundGradient: undefined,
				};
				this.updateStyles( styles );
			},
			disableCustomGradients: false,
			disableCustomColors: false,
			clearable: false,
		} );
		return fields;
	}
	render() {
		const { clientId, enableTextColor, attributes } = this.props;
		const { blockAdvanceOptions } = attributes;
		const _enableTextColor = 'undefined' === typeof enableTextColor ? true : enableTextColor;
		const colors = select( 'core/block-editor' ).getSettings().colors || [];
		return <PanelColorGradientSettings
			title={
				__( 'Color options' )
			}
			initialOpen={
				false
			}
			settings={ this.colorFields() }
			enableContrastChecking={ true }
			clientId={ clientId } >
			<BaseControl>
				<Flex>
					<FlexItem>

					</FlexItem>
					<FlexItem>
						<Button isSecondary isSmall onClick={ () => {
							this.updateStyles( {
								backgroundColor: undefined,
								backgroundGradient: undefined,
							} );
						} }>{ __( 'Clear Background' ) }</Button>
					</FlexItem>
				</Flex>
			</BaseControl>
			{ _enableTextColor && <BaseControl label={ __( 'Text Color' ) } id="textcolor-1">
				<ColorPalette
					colors={ colors }
					value={ blockAdvanceOptions.textColor }
					onChange={ ( color ) => {
						this.updateStyles( {
							textColor: color,
						} );
					} }
				/></BaseControl> }
		</PanelColorGradientSettings>;
	}
}
export default ColorOptions;
